<template>
    <div class="modal duration-100 fade fixed inset-0 bg-blacker bg-opacity-70 bg-blurry hidden" ref="modal" tabindex="-1">
        <div class="flex items-center justify-center h-full">
            <div class="modal-dialog bg-dark rounded-lg inline-block shadow-wide shadow-lg max-w-md w-full md:w-1/2 xl:w-1/3">
                <div class="modal-content">
                    <div class="modal-header border-b border-grey border-opacity-25 px-6 py-4 flex justify-between items-center">
                        <h5 class="modal-title text-lg font-semibold" id="flashModalLabel">Read data information</h5>
                        <button type="button" class="text-grey-400 hover:text-white" data-bs-dismiss="modal" aria-label="Close">
                            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>
                    <div class="modal-body px-6 py-4">
                        <table v-if="flashContents" class="w-full">
                            <tbody>
                                <tr>
                                    <th class="text-left py-2">Length:</th>
                                    <td class="text-left py-2">{{ flashContents.data.length }} bytes</td>
                                </tr>
                                <tr>
                                    <th class="text-left py-2">SHA-1:</th>
                                    <td class="text-left py-2">{{ flashContents.shasum }}</td>
                                </tr>
                                <tr>
                                    <th class="text-left py-2">Is blank:</th>
                                    <td class="text-left py-2" v-if="blank">Yes</td>
                                    <td class="text-left py-2" v-if="!blank">No</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="modal-footer flex justify-end px-4 mb-4 mt-2">
                        <VButton variant="darker" data-bs-dismiss="modal">OKAY</VButton>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { buf2hex } from '../flash/util';
import * as bootstrap from "bootstrap";
import VButton from './VButton.vue';
// import { useTemplateRef } from 'vue'

function isFilledWithFF(uint8Array) {
  return uint8Array.every(byte => byte === 0xFF);
}

export default {
    components: {
        VButton,
    },
    data() {
        return {
            hash: "",
            blank: true
        };
    },
    props: {
        flash: {
            type: Object,
            required: true,
        },
        flashContents: {
            type: Object,
            required: false,
        },
    },
    mounted() {
        this.modal = new bootstrap.Modal(this.$refs.modal, {})
    },
    computed: {
    },
    methods: {
        show() {
            this.modal.show()
        },
        hide() {
            this.modal.hide()
        }
    },
    watch: {
        flashContents() {
            console.log("Data changed")
            if(!this.flashContents) {
                this.blank = true
                return
            }

            if(isFilledWithFF(this.flashContents.data)) {
                this.blank = true
            } else {
                this.blank = false
            }
        }
    }
};
</script>

<style scoped>
/* Add styles if needed */
</style>
